export default "__VITE_ASSET__b283d330__"